import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import GameRulesModal from "../Components/Modals/GameRulesModal";

type Props = NativeStackScreenProps<RootStackParamList, "GameRules">;

const GameRulesScreen: React.FC<Props> = ({ navigation }) => {
  return <GameRulesModal onClose={() => navigation.goBack()} />;
};

export default GameRulesScreen;
